export enum FormViews {
  Compose = 'compose',
  Preview = 'preview',
}
